import { fetchPassCheckReq, verifyPassCheck } from "@/services/common/security.services";
import { toastMessage } from "./myToast";
import Secure from "@/secure/payload";

interface RequestProps {
  openModal: (modalKey: string, props?: any) => void;
  closeModal: () => void;
  modalKey?: string;
  modalProps?: any;
  isSilent?: boolean;
}

export const requestPasswordVerification = (props: RequestProps) => {
  return new Promise((resolve, reject) => {
    let reqInfo: any = null;

    const handleVerifyPassword = async (data: any) => {
      const payload: any = { token: reqInfo?.passCheckToken };

      if (data?.code) {
        payload.code = data?.code;
      }
      if (data?.currentPassword) {
        payload.currentPassword = data.currentPassword;
      }
      if (props?.isSilent) {
        payload.mode = "silent";
      }

      try {
        const res: any = await verifyPassCheck(payload);
        if (res?.status === 200) {
          const { message, isError, showMessage } = res.data;
          if (showMessage) toastMessage(message, isError);
          resolve("");
          props.closeModal();
        } else if (res?.status === 498) {
          props.closeModal();
          const { message, isError } = res?.response?.data || {};
          if (message) {
            return toastMessage(message, isError);
          }
        } else {
          console.log("Error", res);
          const { message, isError } = res?.response?.data || {};
          if (message) {
            return toastMessage(message, isError);
          }
          if (res.message) {
            return toastMessage(res.message, true);
          }
        }
      } catch (error) {
        // Reject the promise on error
        reject(error);
      }
    };

    const handleReject = () => {
      reject("Promise Rejected");
      props.closeModal();
    };

    const passCheckReq = async () => {
      try {
        reqInfo = await fetchPassCheckReq();
        props.openModal(props?.modalKey || "verifyItsYou", {
          handleVerifyPassword,
          handleReject,
          closeModal: handleReject,
          reqInfo: Secure.payloadDecryption(reqInfo),
          modalProps: props.modalProps,
        });
      } catch (error: any) {
        reject(error);
        // Reject the promise on error
        const { message, isError } = error?.response?.data || {};
        if (message) {
          return toastMessage(message, isError);
        }
        if (error.message) {
          return toastMessage(error.message, true);
        }
      }
    };
    passCheckReq();
  });
};

export const requestUserConfirmation = (props: RequestProps) => {
  return new Promise((resolve, reject) => {
    const handleCancel = () => {
      reject("Promise Rejected");
      props.closeModal();
    };

    const handleConfirm = () => resolve("");

    props.openModal(props?.modalKey || "userConfirmation", { handleCancel, handleConfirm, closeModal: handleCancel, modalProps: props.modalProps });
  });
};
